module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/code/warning-1-circle-4d4a7cc690fc30eb0cffc8ca4a515884.svg";